export default (collection, key) => {
  const compare = (a, b) => {
    if (a.isActive === b.isActive) {
      return a[key] - b[key];
    }

    return a.isActive > b.isActive ? -1 : 1;
  };

  return collection.sort(compare);
};
